module.exports = __webpack_public_path__ + "img/icon_account_detail.512f5911.png";